/**
 * Node customizado para reativar bot
 * Reativa a automação que foi pausada por Human Takeover
 * 
 * RELEASE: 1.0.0 - 2025-01-26 - Novo node para sistema de pausa de bot
 */

import { Handle, Position, NodeProps } from '@xyflow/react';
import { Bot } from 'lucide-react';
import { FlowNodeData } from '@/types/flows';
import { FlowNodeToolbar } from './FlowNodeToolbar';

/**
 * Componente visual do node de reativar bot
 */
export function ResumeBotNode({ data, id, selected }: NodeProps) {
  const nodeData = data as FlowNodeData;
  
  // Callbacks injetados via FlowCanvas
  const onEdit = (nodeData as any).onEdit;
  const onDuplicate = (nodeData as any).onDuplicate;
  const onDelete = (nodeData as any).onDelete;
  const onTestFromHere = (nodeData as any).onTestFromHere;

  return (
    <div className="bg-card rounded-lg shadow-lg border-2 border-emerald-500 min-w-[200px] max-w-[240px]">
      {/* Toolbar flutuante */}
      <FlowNodeToolbar
        nodeId={id}
        nodeType={nodeData.type}
        onEdit={onEdit}
        onDuplicate={onDuplicate}
        onDelete={onDelete}
        onTestFromHere={onTestFromHere}
        isVisible={selected}
      />
      
      <Handle
        type="target"
        position={Position.Top}
        className="!bg-emerald-500 !w-3 !h-3"
      />
      
      <div className="p-3">
        <div className="flex items-center gap-2 mb-2">
          <div className="bg-emerald-500/10 text-emerald-600 p-2 rounded">
            <Bot className="h-4 w-4" />
          </div>
          <div className="flex-1">
            <div className="font-semibold text-sm text-foreground">
              {nodeData.config?.nickname || 'Reativar Bot'}
            </div>
          </div>
        </div>
        
        <div className="text-xs text-muted-foreground bg-muted/50 rounded p-2">
          Reativa automação
        </div>
      </div>
      
      <Handle
        type="source"
        position={Position.Bottom}
        className="!bg-emerald-500 !w-3 !h-3"
      />
    </div>
  );
}
